import { Card, CardBody, Col } from "reactstrap";
import { Image, LI, UL } from "../../../AbstractElements";
import { GroupingTitle } from "../../../Constants/Constants";
import { AvatarGroupData, GroupSubTitle } from "../../../Data/UiKits/Avatars";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Grouping = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={GroupingTitle} span={GroupSubTitle} />
        <CardBody>
          <div className="avatars avatar-showcase">
            {AvatarGroupData &&
              AvatarGroupData.map((data) => (
                <div className="customers d-inline-block avatar-group" key={data.id}>
                  <UL className="simple-list">
                    {data.child &&
                      data.child.map((item) => (
                        <LI className="d-inline-block" key={item.id}>
                          <Image className={`img-${item.class}`} src={dynamicImage(`${item.image}`)} alt="user profile" />
                        </LI>
                      ))}
                  </UL>
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Grouping;
